
import './App.css';
import { Datagrid } from './components/Datagrid';


function App() {
  return (
    <div className="App">
   <h1 className='heading' >User Data Grid</h1>
    <Datagrid/>
    </div>
  );
}

export default App;
